// Utility helpers
const query = (s, el = document) => el.querySelector(s);
const queryAll = (s, el = document) => Array.from(el.querySelectorAll(s));

const header = query('[data-header]');

// --- Focus helpers ---
function focusFirstLink(container) {
    if (!container) return;
    const first = container.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (first) first.focus();
}

// Desktop: open/close trays (dropdown + megamenu)
queryAll('.has-dropdown, .has-megamenu').forEach(item => {
    const btn = item.querySelector('button');
    const tray = item.querySelector('.nav-tray');

    const close = () => {
        btn.setAttribute('aria-expanded', 'false');
        tray.classList.remove('__active');
        header.classList.remove('__active');
    };
    const open = () => {
        btn.setAttribute('aria-expanded', 'true');
        tray.classList.add('__active');
        header.classList.add('__active');
    };

    btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        // close all first
        queryAll('.nav-tray.__active').forEach(p => p.classList.remove('__active'));
        queryAll('.nav > li > button[aria-expanded="true"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
        if (!isOpen) open();
        else close();
    });

    // Dismiss on Escape and outside click
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            close();
            btn.focus();
        }
    });
    document.addEventListener('click', e => {
        if (!item.contains(e.target) && !query('#searchDialog').contains(e.target)) close();
    });
});

// Megamenu menu tabs (desktop)
function activateTab(btn) {
    const group = btn.closest('.megamenu');
    queryAll('[role="tab"]', group).forEach(t => t.setAttribute('aria-selected', 'false'));
    btn.setAttribute('aria-selected', 'true');
    queryAll('.megamenu-tabpanel', group).forEach(p => p.classList.remove('__active'));
    const panel = query('#' + btn.getAttribute('aria-controls'));
    panel.classList.add('__active');
    // Put users straight on the first link in the new panel
    focusFirstLink(panel);
}
queryAll('[role="tab"]').forEach(btn => {
    btn.addEventListener('click', () => activateTab(btn));
    btn.addEventListener('keydown', e => {
        const tabs = queryAll('[role="tab"]', btn.closest('.tabs'));
        const i = tabs.indexOf(btn);
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            tabs[Math.min(i + 1, tabs.length - 1)].focus();
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            tabs[Math.max(i - 1, 0)].focus();
        }
    });
});

// Search overlay
const searchBtn = query('#openSearch');
const searchDlg = query('#searchDialog');
const searchInput = query('#q');

function openSearch() {
    closeMobile();
    searchDlg.classList.add('__active');
    searchBtn.setAttribute('aria-expanded', 'true');
    header.classList.add('__active');
    setTimeout(() => searchInput.focus(), 10);
}
function closeSearch() {
    searchDlg.classList.remove('__active');
    searchBtn.setAttribute('aria-expanded', 'false');
    header.classList.remove('__active');
}
searchBtn.addEventListener('click', () => {
    const open = searchDlg.classList.contains('__active');
    open ? closeSearch() : openSearch();
});
document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
        closeSearch();
        searchBtn.focus();
    }
});
searchDlg.addEventListener('click', e => {
    if (e.target === searchDlg) closeSearch();
});

// Mobile drawer
const drawer = query('#mobileOffcanvas');
const openMenuBtn = query('#openMenu');

function openMobile() {
    closeSearch();
    drawer.classList.add('__active');
    drawer.setAttribute('aria-hidden', 'false');
    openMenuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    header.classList.add('__active');
    focusFirstLink(drawer);
}
function closeMobile() {
    drawer.classList.remove('__active');
    drawer.setAttribute('aria-hidden', 'true');
    openMenuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    header.classList.remove('__active');
    // close any subtrays
    queryAll('.mobile-tray').forEach(p => {
        p.classList.remove('__active');
        p.setAttribute('aria-hidden', 'true');
    });
}
openMenuBtn.addEventListener('click', () => {
    const isOpen = drawer.classList.contains('__active');
    isOpen ? closeMobile() : openMobile();
});

// Mobile subtray openers (dropdown + megamenu)
queryAll('.mobile-item[data-tray-target]').forEach(btn => {
    const target = query(btn.getAttribute('data-tray-target'));
    btn.addEventListener('click', () => {
        queryAll('.mobile-tray').forEach(p => {
            p.classList.remove('__active');
            p.setAttribute('aria-hidden', 'true');
        });
        target.classList.add('__active');
        target.setAttribute('aria-hidden', 'false');
        focusFirstLink(target);

        // If this is a mobile megamenu panel, initialise it to level 2 (tabs)
        if (target.classList.contains('mobile-megamenu')) {
            initMobileMegamenu(target);
        }
    });
});

// Back buttons on subtrays, including mobile-megamenu levels
queryAll('.mobile-tray [data-back]').forEach(btn =>
    btn.addEventListener('click', () => {
        const mega = btn.closest('.mobile-megamenu');
        const track = mega && query('.mobile-megamenu-track', mega);

        // If the back button lives in a level-3 tray, go back to tabs (level 2)
        if (btn.closest('.mobile-megamenu-tray') && track) {
            track.classList.remove('level-3');
            track.classList.add('level-2');

            // Hide all level-3 trays
            queryAll('.mobile-megamenu-tray', mega).forEach(p => (p.hidden = true));

            // Focus the corresponding tab button for the last active tray
            const activeKey = track.dataset.activeTab;
            const tabBtn = activeKey && query(`.mobile-megamenu-view--tabs .mobile-item[data-tab="${activeKey}"]`, mega);
            if (tabBtn) tabBtn.focus();
            else focusFirstLink(query('.mobile-megamenu-view--tabs', mega));
            return;
        }

        // Otherwise, close this subtray and return focus to its opener (level 1)
        const p = btn.closest('.mobile-tray');
        p.classList.remove('__active');
        p.setAttribute('aria-hidden', 'true');
        const opener = p.id ? query(`[data-tray-target="#${p.id}"]`) : null;
        if (opener) opener.focus();
        else openMenuBtn.focus();
    })
);

// Close mobile on ESC
document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
        closeMobile();
        openMenuBtn.focus();
    }
});

// --- Mobile Megamenu Helpers ---
function initMobileMegamenu(panel) {
    const track = query('.mobile-megamenu-track', panel);
    if (!track) return;

    // Reset to level 2 (tabs)
    track.classList.remove('level-3');
    track.classList.add('level-2');

    // Hide all level-3 trays (match your markup)
    queryAll('.mobile-megamenu-tray', panel).forEach(p => (p.hidden = true));

    // Wire tab buttons once
    if (!panel.dataset.wired) {
        queryAll('.mobile-megamenu-view--tabs .mobile-item', panel).forEach(tabBtn => {
            tabBtn.addEventListener('click', () => openMobileMegamenu(panel, tabBtn));
        });
        panel.dataset.wired = '1';
    }
}

function openMobileMegamenu(panel, tabBtn) {
    const track = query('.mobile-megamenu-track', panel);
    const key = tabBtn.getAttribute('data-tab');
    if (!track || !key) return;

    // Show matching level-3 tray
    queryAll('.mobile-megamenu-tray', panel).forEach(p => {
        p.hidden = p.getAttribute('data-tray') !== key;
    });

    // Slide to level 3 and remember which tab is active
    track.classList.remove('level-2');
    track.classList.add('level-3');
    track.dataset.activeTab = key;

    // Wait for CSS transition to finish before focusing
    const activeTray = query(`.mobile-megamenu-tray[data-tray="${key}"]`, panel);
    if (activeTray) {
        setTimeout(() => focusFirstLink(activeTray), 300);
    }
}